import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { gql } from '@/__generated__/index.ts';

const SignupTrialUpgradeCheckoutMutation = gql(`
  mutation SignupTrialUpgradeCheckout($streamId: ID!, $customTargetsCheckoutData: CustomTargetsCheckoutData!) {
    streamSignupTrialUpgradeCheckout(streamId: $streamId, customTargetsCheckoutData: $customTargetsCheckoutData) {
      url
    }
  }
`);

export const useSignupTrialUpgradeCheckout = () => {
  const toast = useToast();

  const [mutate, result] = useMutation(SignupTrialUpgradeCheckoutMutation, {
    onError: (e) => {
      toast.error({
        title: 'Failed to start checkout',
        subTitle: e.message,
      });
    },
  });

  const startCheckout = async (quantity: number, streamId: string) => {
    const { data } = await mutate({
      variables: {
        streamId,
        customTargetsCheckoutData: { quantity },
      },
    });
    return data?.streamSignupTrialUpgradeCheckout.url;
  };

  return [startCheckout, result] as const;
};
